import React from 'react';
import {
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Paragraph,
  Hr,
  LinkStyled,
} from '../components/typography';
import { Container, Row, Col } from '../components/grid';
import { LiterPriceDifference, PricePrLiter, Item } from '../containers/commerce';
import { FadoelAlternativeView1, FadoelAlternativeView2 } from '../components/commerce/Item';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Billigt">
    <Container white>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading1 margin="0 0 10px">
            Billig fadøl - Spar <LiterPriceDifference vareA={3615} vareB={4615} multiplier={25} />,- pr. fustage
          </Heading1>
          <Heading4>Vi sælger Danmarks billigste kvalitets fadøl</Heading4>
          <Paragraph fontSize="12px">
            Øllets besparelse er beregnet ud fra Grøn Tuborgs literpris på kr. <PricePrLiter varenr={3615} />
          </Paragraph>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Item
            varenr={4615}
            display={FadoelAlternativeView1}
            singleWidth={[
              [991, '100px'],
              [1199, '100px'],
              '100px']
            }
            customText="Royal Pilsner er nu vores billigste fadøl. Læg mærke til den meget lave literpris. Brygget på Royal Unibrews egen Royal malt er Royal Pilsner en mild, let og smagsfuld fadøl."
          />
        </Col>
        <Col xs={12} md={6}>
          <Item
            varenr={8285}
            display={FadoelAlternativeView1}
            singleWidth={[
              [991, '100px'],
              [1199, '100px'],
              '100px']
            }
            customText="
            Skovlyst Bikrkebryg Pilsner er en udsøgt dansk fadøl brygget med stor inspiration fra den tjekkiske pilsner.
            Denne pilsner har en flot gylden farve og en meget lækker smag.
            Dette kombineret med den gode pris gør denne fadøl til en meget populær fadøl, som helt sikkert vil falde i god jord hos dine gæster."
          />
        </Col>
        <Col xs={12} md={6}>
          <Item
            varenr={12655}
            display={FadoelAlternativeView1}
            singleWidth={[
              [991, '100px'],
              [1199, '100px'],
              '100px']
            }
            customText="Depot Classic er det samme som Vestfyen Classic, som er en rød-gylden øl med en sød maltet aroma, hvilket den smagmæssigt også bærer præg af kombineret med en anelse bitterhed."
          />
        </Col>
        <Col xs={12} md={6}>
          <Item
            varenr={4815}
            display={FadoelAlternativeView1}
            singleWidth={[
              [991, '100px'],
              [1199, '100px'],
              '100px']
            }
            customText="Albani Odense Pilsner er fynboernes foretrukne pilsner! Pilsneren har en genkendelig harmonisk, frisk og elegant smag."
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} textCenter>
          <Heading2 margin="0 0 10px">På lager i store mængder!</Heading2>
          <Heading3>Andre gode og billige fadøl</Heading3>
        </Col>
        <Col xs={12} md={6} lg={3}>
          <Item
            varenr={4655}
            display={FadoelAlternativeView2}
            singleWidth={[
              [991, '50px'],
              [1199, '50px'],
              '50px']
            }
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <Item
            varenr={8415}
            display={FadoelAlternativeView2}
            singleWidth={[
              [991, '50px'],
              [1199, '50px'],
              '50px']
            }
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <Item
            varenr={8435}
            display={FadoelAlternativeView2}
            singleWidth={[
              [991, '50px'],
              [1199, '50px'],
              '50px']
            }
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <Item
            varenr={8245}
            display={FadoelAlternativeView2}
            singleWidth={[
              [991, '50px'],
              [1199, '50px'],
              '50px']
            }
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Heading2>Køb billig fadøl hos Skafte</Heading2>
          <Paragraph>
            Her på siden har vi samlet nogle af de typer fadøl, hvor du får den skarpeste pris.
          </Paragraph>
          <Paragraph>
            Tager man udgangspunkt i den klassiske fadølsvariant Grøn Tuborg, har denne en literpris på 31,00 kr. Dette er en højt værdsat og velkendt ølvariant, der er elsket af mange.
            Nogle gange kan det dog sagtens betale sig at vælge den billigere løsning. Billig fadøl er nemlig stadig fyldt med masser af smag og den skønne, boblende fornemmelse på tungen.
            Du finder billig fadøl med en literpris helt ned til 24,00 kr. pr. liter - det bliver faktisk ikke en skarpere pris.
          </Paragraph>
          <Paragraph>
            Husk at <LinkStyled to="/fadoelsanlaeg">leje et fadølsanlæg</LinkStyled> til din fustage med billig fadøl. Hos Skafte finder du flere størrelser på fadølsbarer og haner, så du kan vælge den variant, der passer perfekt til antallet af gæster og festens omfang.
          </Paragraph>
        </Col>
      </Row>
      <Hr />
      <Row>
        <Col xs={12} md={6}>
          <Heading2>Smag Platan Pilsner i København</Heading2>
          <Paragraph>
            Platan Pilsner bliver blandt andet solgt på de tre nedenstående caféer i København.
            Så hvis vil smage den lækre tjekkiske øl før du køber den i store mængder, så kig forbi et af disse 3 steder (listen blev senest opdateret d. 23 okt. 2014).
          </Paragraph>
          <Row>
            <Col xs={12} md={6}>
              <Paragraph>
                Restaurant Fuego<br />
                Holbergsgade 14<br />
                1057 Kbh K
              </Paragraph>
            </Col>
            <Col xs={12} md={6}>
              <Paragraph>
                Jazz Cup<br />
                Gothersgade 107<br />
                1123 Kbh K
              </Paragraph>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6}>
          <Heading2>Smag Depot fadøl i København</Heading2>
          <Paragraph>
            Depot fadøl kan smages på de følgende steder i København:
          </Paragraph>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <Paragraph>
                Høvlen<br />
                Prinsessegade 77<br />
                1422 København K
              </Paragraph>
            </Col>
            <Col xs={12} sm={6}>
              <Paragraph>
                Brønshøj Bodega<br />
                Frederikssundsvej 189<br />
                2700 Brønshøj
              </Paragraph>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
